<mc-file-watcher (changed)="update($event)"></mc-file-watcher>

<mc-tags-list [tags]="tags"></mc-tags-list>
